export const reduxKey = '@@groupGallectionSelector';

//# sourceMappingURL=constants.js.map